<template>
  <!--
  <div>
  -->
  <mu-dialog :open='true'>
    <div class="game-container" :class="{show: show}">
      <loading :type="type" v-show="!startGame && verbalShow" style="position:absolute;z-index: 20141399!important;"></loading>
      <div style="
        width: 1280px;
        height:1000px;
        margin:0 auto;
        overflow:visible;
      ">
        <iframe  
          class     = "game-iframe"
          name      = "openGames"
          :src      = "gameUrl"
          scrolling = "no"
          ref       = 'gameContainer'
        >
        </iframe>
      </div>
    </div>
  </mu-dialog>
  <!--
  </div>
  -->
</template>
<script>
  import Vue from 'vue'
  import {mapState,mapMutations} from 'vuex'
  import loading from './loading.vue'
  import {curDate} from '../../assets/js/common.js'
  // 发送消息的interval
  var _t = null;
  var userID = '';
  // 游戏iframe相关最佳宽高
  var iframe = {
    dom: null,
    bestWidth: 1280,
    bestHeight: 800,
    bestRatio: 1.6
  };
  var wrapper = $(".mu-dialog-wrapper").attr("style")
  var overlay = $(".mu-overlay").attr("style")
  export default ({
    props:['gameData','gameFlag','caseId','caseName','todayGames','rest'],
    data() {
      return{
        store: require('../../app/store.js'),
        address: GLOBAL,

         /* loading相关的状态 */
        type:"cogn",
        games: {},
        game: {
          gameId: '',
          name: '',
          para: {},
          /* jshint ignore:start */
          game_sno: [],
          /* jshint ignore:end */
          skin: {},
          duration: '',
          url: '',
          cogn: [],
          as: ''
        },
        gameUrl: '',
        // 选中的脑能力
        selectedCogn: {
          code: '',
          name: '',
          description: ''
        },
        remLevel: "",  // 开始等级
        // 游戏code
        gameId: '',
        // 患者uuid
        patientId: '',
        // 游戏运行状态
        running: false,
        // 游戏是否显示
        show: false,
        // 开始页面是否显示
        start: true,
        // 结束页面是否显示
        end: false,
        // 下一个游戏的code
        nextGameCode: '',
        // 游戏训练的数据，用于游戏iframe中
        trainInfo: {
          url: '/api/UserDailyTraining/saveCognGame',
          address: GLOBAL,
          gameId: null,
          user: null,
          as: null,
          title: null,
          config: {},
          levelDefs: "",
          startLevel: null,
          isFirstTraining: null,
          lastLevel: null,
          gametime: 30,
          gamedata: null,
          postback: {lesson: 'b', tid:'',pid:''}
        },

        //游戏结束提交参数相关
        start_time:"",//游戏开始时间
        end_time:"",//游戏结束时间
        duration:"",//游戏持续时间

        // 游戏分数
        lastScore: '0',
        score: {
          currentScore: '',
          highestScore: '',
          advancement: '',
        },
        // 游戏iframe
        iframe: {
          left: 0,
          width: iframe.bestWidth,
          height: iframe.bestHeight
        },
        // 是否是体验游戏
        isExperience: false,
        // 是否是医生训练游戏
        isDoctorTraining: false,
        // 错误保存次数
        saveTimes: 1,
        // 游戏已玩的次数
        gameCount: 0,
        //实际的训练时长
        trainTime:"",
        //展示1.0言语游戏
        verbalShow:true,
        totalScore:0,
      }
    },
    components:{
      loading,
    },
    created(){
      console.log(this.rest);
      if(this.gameData.lesson_type == 'b'){
        this.type = "cogn";
      }else{
        this.type = "lan";
      }
    },
    computed:{
      ...mapState(["hardNum","startTime","startGame"])
    },
    mounted () {
      //'gameData','gameFlag','caseId','caseName','todayGames','rest'
      if(navigator.userAgent.match(/iPad/i))
      {
        let gc = this.$refs.gameContainer;
        let args = {
          scw: screen.width,
          sch: screen.height,
          ww: window.innerWidth,
          wh: window.innerHeight,
          cw: gc.clientWidth,
          ch: gc.clientHeight,
        };
        let tx = -(args.ww - args.cw);
        let ty = (args.wh - args.ch)/2;
        let sx = args.ww / args.cw;
        let sy = args.wh / args.ch;
        let sc = [[args.wh, sy],[args.ww, sx]].filter((x)=>(x[1] * args.cw <= args.ww && x[1] * args.ch <= args.wh))[0][1];
        if (sc > 1)        
        {
          ty = '25%';
        }
        else
        {
          ty = `${ty}px`;
        }
        let transform = `translate(-50%, ${ty}) scale(${sc}, ${sc})`;
        this.$refs.gameContainer.style.transform = transform;
      }
      console.log("#################");
      console.log(this.gameFlag);
      //每次开始游戏先加载loading动画
      this.$store.commit("changeGame",false);
      window.onload = function(){

      }
      if (!iframe.dom) {
        iframe.dom = document.querySelector('iframe.game-iframe');
        // 首次进入后居中显示
        $(".game-iframe").css({
          'postion': 'fixed',
          'z-index': '20141299'
//          'right': (document.body.clientWidth-1280)/2,
//          'left': (document.body.clientWidth-1280)/2
        });
        // iframe发送回来的消息
        window.addEventListener('message', this.message, false);
      }
      $(".game-container").css({
        'postion': 'fixed',
        'left': '0',
        'top': '0',
        'right': '0',
        'z-index': '99999999999'
      });
      this.getGameHisLev();
    },
    destroyed (){
      // 清除iframe，避免切换用户时游戏无法退出的问题
      if (iframe.dom) {
        iframe.dom.parentNode.remove();
        iframe.dom = null;
        window.removeEventListener('message', this.message, false);
      }
    },
    methods: {
      //获取游戏上次等级
      getGameHisLev: function(){
        var self = this;
        if(this.gameData.taskId){
          this.gameData["id"] = this.gameData.taskId;
        }
        console.log(this.gameData);
        Vue.http({
            method: 'GET',
            url:'/api/Game/GameLevel',
            params: {
              'gameId': this.gameData.id,
              'patientId': this.caseId
            }
          })
          .then(
            function(res){
              self.trainInfo.levelDefs = res.data.data.level;
              if(typeof res.data.data.count != "undefined"){
                self.gameCount = res.data.data.count;
              }
              self.showGame(self.gameData,self.gameFlag);
            }
          )
      },
      // 开始游戏
      showGame: function(item,flag) {
        console.log("@@@@@@@@@@@@@@@@@@");
        console.log(item);
        var self = this;
        // 1.0的认知游戏
        if (item.tag){
          $(".rightContent").css({
            'margin-right': '-17px'
          });
          if(item.lesson_type=='l'){
            self.verbalShow=false;
            //向1.0游戏里传入自定义的时间，训练体验默认只给30秒
            if( flag == 1){
              self.$refs.gameContainer.transform = '';
              self.gameUrl = GLOBAL.verbal_cognition+"/"+this.gameData.proto + `?time=` + this.startTime * 60;
            }else{
              self.gameUrl = GLOBAL.verbal_cognition+"/"+this.gameData.proto + `?time=30`
            }
          }else{
            self.verbalShow=true;
            self.gameUrl = GLOBAL.cognition+'/game/'+item.proto+'?embed=true&ts=02051700';
          }
          
          this.show = true;
          this.game_id = item.id;
          var userName = '';
          var times = 30;
          var temLastLevel = 1;
          var temStartLevel = 1;
          console.log(this.rest);
          if (flag && this.rest == 0){
            // 正式训练并且不是再练一次，使用的是设置的难度等级
            userID   = this.caseId;
            times = this.startTime * 60;
            userName = this.caseName;
            temLastLevel = this.trainInfo.levelDefs;
            temStartLevel = this.hardNum.toString();
          } else if (flag && this.rest == 1){
            // 正式训练而且是再练一次，使用的是接口继承的难度等级
            userID   = this.caseId;
            times = this.startTime * 60;
            userName = this.caseName;
            temLastLevel = this.trainInfo.levelDefs;
            temStartLevel = temLastLevel;
            this.$emit("update:rest", 0);//修改父组件传过来的rest的值
          } else {
            // 临时训练
            userID  = this.store.account.id;
            userName = this.store.account.name;
          }
          // 初始难度由后台控制，默认都不是首次训练
          var trainInfo = {
            gameId: this.game_id,
            user: {id: userID, name: userName},
            startLevel: temStartLevel,
            isFirstTraining: 1, // this.gameCount>0?0:1
            lastLevel: temLastLevel,
            levelDefs: null,
            gametime: times,
            gamedata: '',
            as: item.args.as,
            postback: {lesson: 'b',tid: item.id, pid: item.p_id, gametime:times, uid: userID}
          };
          this.trainInfo.postback = trainInfo.postback;
          _t = setInterval(function() {
            try
            {
              if(!self.running) {
                window.frames[0].postMessage({action: 'start_game', trainInfo: trainInfo, time:times}, '*');
              }
            }
            catch(ex)
            {
            }
          }, 100);
        } else if (item.pathId){
          $(".rightContent").css({
            'margin-right': '-17px'
          });
          for(var i=0; i<this.address.lanGames.length; i++){
            if(item.id == this.address.lanGames[i].trainID){
              var title = this.address.lanGames[i].title;
              break;
            }
          }
          console.log(this.todayGames);
          var nextID = [];
          if(this.todayGames){
            this.todayGames.forEach(function(e){
              nextID.push(e.taskId);
            });
          } else {
            nextID = item.id;
          }
          if(flag == 0){
            this.caseId = '';
          }
          this.gameUrl = GLOBAL.lan_cognition+'/game2/'+title+'/index.html?trainId='+this.caseId+'&taskId='+item.id+'&token='+localStorage.access_token+'&nextId='+nextID+'&uid='+this.caseId;
          console.log(this.gameUrl);
        }
      },
      // 提交游戏分数
      submitScore: function (data) {
        console.log(data);
        data["start_time"] = this.start_time;
        data["end_time"] = this.end_time;
        data["train_time"] = this.duration;
        data["start_level"] = data.lastLevel;
        var self = this;
        var submitObj = {gameId: data.gameId, data: data };
        if (this.isDoctorTraining) {
          submitObj.patientId = this.patientId;
        }
        self.$http.post(this.trainInfo.url,submitObj,
        {emulateJSON: true})
          .then((score)=>{
            this.start = false;
            this.show = false;
            this.end = true;
            if(score.data.game_info.last_score || score.data.game_info.last_score == 0){
              this.lastScore = score.data.game_info.last_score;
            }
            $(".rightContent").css({
              'margin-right': '0'
            });
            this.$store.commit("changeGame",false);
            // 游戏结束,回传分数
            console.log(this.gameData);
            console.log("????????????????????");
            console.log(this.lastScore);
            console.log(this.totalScore);
            this.$emit("updateScore",data,this.gameData.name,this.lastScore);
            console.log(data);
            console.log(this.gameData.name);
            // console.log('recved ' + JSON.stringify(val) + ' from ' + event.origin);

            // 改变父组件的判断条件，使之可连续打开新的
            // 使用muse-ui之后，$parent方式就不稳定了，故使用emit方式改变父组件属性值
            this.$emit("close");
          })
          .catch(function () {
            self.saveTimes ++;
            if(self.saveTimes < 3){
              self.submitScore(data);
            }
          });
      },
      formate(time){
        var hour,min,sec,target;
        hour = time.getHours();
        min = time.getMinutes();
        sec = time.getSeconds();
        if(hour < 10){
          hour = "0" + hour;
        }
        if(min < 10){
          min = "0" + min;
        }
        if(sec < 10){
          sec = "0" + sec;
        }
        target = curDate(time) + " " + hour + ":" + min + ":" + sec;
        return target;
      },
      // iframe发送过的消息
      message: function (event) {
        var val = event.data;
        // 开始游戏发送消息标识
        console.log(val);
        if(val.action == "start_cogn"){
          console.log("start_cogn%%%%%%%%%");
          console.log(val.start_time);
          this.start_time = this.formate(val.start_time);
        }
        if(val.action === 'loading'){
          this.$store.commit("changeGame",true);
        }
        if(val.action === 'lan_start'){
          //关闭认知游戏加载动画
          this.$store.commit("changeGame",true);
        }
        if(val.action === 'start_game'){
          //关闭认知游戏加载动画
          this.$store.commit("changeGame",true);
        }
        //1.0游戏新增退出按钮
        if(val.action === 'jump_out'){
          //关闭认知游戏加载动画
          this.$emit("close");
        }
        //1.0游戏新增退出按钮

        if (val.start_game === 'ok') {
          this.running = true;
          clearInterval(_t);
        } else if (val.action === 'game_over' || val.action === 'endGame') {

          //认知游戏结束
          console.log("endGame%%%%%%%%%");
          this.totalScore = val.trainInfo.transcript.score;
          console.log(val);
          this.end_time = this.formate(val.end_time);
          this.duration = Math.ceil(val.trainTime/1000);

          this.running = false;
          this.trainTime = val.trainInfo.postback.gametime;
          this.$store.commit("postTrainTime",this.duration);
          var lastObject = val.trainInfo.transcript;
          // 打开游戏无论是否训练，都要保存，否则无法获取上次分数
          this.submitScore(JSON.parse(JSON.stringify(val.trainInfo)));
          // 添加打开游戏后直接跳出后的等级判断
          if(lastObject.length > 0 ){
            var lastObjectLevel = lastObject[lastObject.length-1].levelDef.level; //游戏结束后最终的难度
            this.remLevel = lastObjectLevel;
            // 如果打开游戏不训练，则不执行保存
            // if (undefined != val.trainInfo) {
            //   try {
            //     this.submitScore(JSON.parse(JSON.stringify(val.trainInfo)));
            //   } catch(ex) {
            //     console.log(ex);
            //   }
            // }
          } else {
            this.remLevel = this.trainInfo.startLevel;
          }
        } else if (val.action === 'lan_game_back_home'){
          this.running = false;
          console.log(val.titleVal)
          this.$emit("restart",val.titleVal);
        }
      }
    }
  })
</script>
<style lang="stylus">
  @import "../../assets/css/app.styl";
  @import "../../assets/css/variable.styl";

/*  .iframe-wrapper
    -webkit-overflow-scrolling touch
    overflow auto*/
  /* 展示游戏页面*/
  .game-iframe
    position absolute
    top 0
    left 50%
    transform translateX(-50%)
    -webkit-transform translateX(-50%)
    z-index 9
    border none
    max-width 1280px
    max-height 800px
    margin-left 0
    width 1280px
    height 800px
  @media (-webkit-max-width: 1366px) and (-webkit-min-width: 1280px),(max-width:1366px) and (min-width:1280px)
    .game-iframe
      width:1024px;
      height:640px;
  @media (-webkit-max-width: 1280px) and (-webkit-min-width: 1024px),(max-width:1280px) and (min-width:1024px)
    .game-iframe
      width 1024px
      height 600px
  @media (-webkit-max-width: 1024px),(max-width:1024px)
    .game-iframe
      width 1024px
      height 650px
</style>



// WEBPACK FOOTER //
// trainCronSave.vue?a914301c